/* import __COLOCATED_TEMPLATE__ from './ios-push-component.hbs'; */
/* RESPONSIBLE TEAM: team-messenger */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class IosPushComponent extends Component {
  @tracked sdkApp = this.args.sdkApp || {};
}
